<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/dGj7fz/tc-custom/9781626810341.jpg?1706066617707" alt="This image is the cover for the book Warrior Heart, The Wolf McCloud Novels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Warrior Heart, The Wolf McCloud Novels
      </h1>
      <p class="bookDescription body article font2">
        <b>When a father returns home to reclaim his daughter, a heated conflict with the woman who raised her turns to a chance for love in this western romance.</b><br/>  <br/><i>California, 1891.</i> After losing his wife in a violent attack, Jackson Wolfe ran from his grief and his guilt, leaving behind his baby daughter to be raised by strangers. Twelve years later, he knows it’s time to quit running. He’s had his fill of revenge. It’s time to settle down and take up a new mantle: father to Dawn Twilight. He knows that if he finds her, he’ll be the best father a little girl ever had. But when he arrives in the town of Thief River to be the new sheriff and claim his daughter, her adoptive mother has other plans.<br/>  <br/> Liberty O’Malley has never loved anyone like she loves Dawn. But in the court of law, she knows she has little chance of keeping her against the will of the town’s new sheriff. Yet even in the pain of her heart she can see a way to nurture the seeds of love. But to do it, she’ll have to soothe Jackson’s wounded heart first . . .<br/>  <br/> “Jane Bonander reaches to her readers’ hearts.” —<i>RT Book Reviews</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jane Bonander
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Diversion Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?cc3b5bc0